import { z } from "incur";

export const AuthMethod = z.enum(["api_key", "oauth"]);
export type AuthMethod = z.infer<typeof AuthMethod>;

export const Identity = z.object({
	id: z.string().optional().describe("Account or user id"),
	title: z.string().optional().describe("Account display name or user name"),
	route: z.string().optional().describe("The account's public route"),
	email: z.string().optional().describe("User email address (oauth only)"),
});
export type Identity = z.infer<typeof Identity>;

export const Profile = z.preprocess(
	(value) => {
		if (!value || typeof value !== "object" || Array.isArray(value))
			return value;
		const profile = value as Record<string, unknown>;
		return {
			...profile,
			accountId: profile.accountId ?? profile.companyId,
			accountTitle: profile.accountTitle ?? profile.companyTitle,
			accountRoute: profile.accountRoute ?? profile.companyRoute,
			companyId: profile.accountId ?? profile.companyId,
			companyTitle: profile.accountTitle ?? profile.companyTitle,
			companyRoute: profile.accountRoute ?? profile.companyRoute,
		};
	},
	z.object({
		name: z.string().describe("The local profile name"),
		method: AuthMethod,
		accountId: z.string().optional(),
		accountTitle: z.string().optional(),
		accountRoute: z.string().optional(),
		companyId: z.string().optional(),
		companyTitle: z.string().optional(),
		companyRoute: z.string().optional(),
		userId: z.string().optional(),
		userEmail: z.string().optional(),
		createdAt: z
			.string()
			.describe("ISO timestamp of when the profile was first created"),
	}),
);
export type Profile = z.infer<typeof Profile>;
